



























/**
 * Le nom "Link" est réservé en html, on utilise donc le nom en français pour ce composant
 */
import {defineComponent} from 'vue';
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: 'Lien',
    props: {
        isButton: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: undefined
        },
        isTextLink: {
            type: Boolean,
            default: true
        },
        noDecoration: {
            type: Boolean,
            default: false
        },
        isLinkArrow: {
            type: Boolean,
            default: false
        },
        isLinkArrowBack: {
            type: Boolean,
            default: false
        },
        isMini: {
            type: Boolean,
            default: false
        },
        isLarge: {
            type: Boolean,
            default: false
        },
        preventDefault: {
            type: Boolean,
            default: false
        },
        openNewTab: {
            type: Boolean,
            default: false
        },
        // id de la modal
        modalId: {
            required: false,
            type: String,
            default: null
        },
        ariaLabel: {
            required: false,
            type: String,
            default: null
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ''
        },
        tmsAction: {
            type: String,
            required: false,
            default: undefined
        },
        tmsLabel: {
            type: String,
            required: false,
            default: undefined
        }
    },
    computed: {
        classes(): Record<string, boolean> {
            return {
                "ob1-link": this.isTextLink,
                "no-decoration": this.noDecoration,
                "ob1-link-arrow": this.isLinkArrow,
                "ob1-link-arrow back": this.isLinkArrowBack,
                "ob1-link-small": this.isMini,
                "ob1-link-large": this.isLarge
            };
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: this.tmsAction?.trim() ? toBroadbandTmsFormat(this.tmsAction) : toBroadbandTmsFormat(this.label),
                label: this.tmsLabel?.trim() ? toBroadbandTmsFormat(this.tmsLabel) : toBroadbandTmsFormat(this.href)
            }
        }
    },
    methods: {
        clickHandler(event: Event): void {
            if (this.preventDefault) {
                event.preventDefault();
            }
            this.$emit("click");
        }
    }
});
